import { resetWorkerReadyState } from '../client-state.js';
import { postToWorker, requestWorker } from './start.js';
import { terminateSymbolIndexWorker } from './shutdown.js';
import { resetLifecycleStateForTests } from './state.js';
import { resetSymbolIndexWorkerShutdownForTests } from '../shutdown-state.js';

export { postToWorker, requestWorker, terminateSymbolIndexWorker };

export function resetSymbolIndexWorkerLifecycleForTests(): void {
  resetLifecycleStateForTests();
  resetWorkerReadyState();
  resetSymbolIndexWorkerShutdownForTests();
}
